import React, { Component } from "react";
import "../App.css";
import { Button, Form, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import setpass from "../assets/setpass.svg";
import setpass2 from "../assets/setpass2.svg";

const passRegex = new RegExp("^((?=.*[a-z])|(?=.*[A-Z]))(?=.*[0-9])");

class SetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordErrorText: "",
      repasswordErrorText: "",
      passwordValue: "",
      repasswordValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
    };

    this.passwordHandleChange = this.passwordHandleChange.bind(this);
    this.repasswordHandleChange = this.repasswordHandleChange.bind(this);
    this.LoginUser = this.LoginUser.bind(this);
  }

  loginClick = () => {
    this.setState({ actionError: "" });

    let password = document.getElementById("password");
    let repassword = document.getElementById("repassword");

    if (this.state.passwordValue === "") {
      password.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ passwordErrorText: "لطفاً رمز عبور خود را وارد کنید" });
      return;
    } else {
      password.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ passwordErrorText: "" });
    }

    if (this.state.passwordValue.length >= 8) {
      password.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ passwordErrorText: "" });
    } else {
      password.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ passwordErrorText: "رمز عبور باید حداقل 8 رقم باشد" });
      return;
    }

    if (passRegex.test(this.state.passwordValue)) {
      password.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ passwordErrorText: "" });
    } else {
      password.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({
        passwordErrorText: "رمز عبور باید ترکیبی از حروف انگلیسی و عدد باشد",
      });
      return;
    }

    if (this.state.repasswordValue === "") {
      repassword.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({
        repasswordErrorText: "لطفاً رمز عبور خود را تکرار کنید",
      });
      return;
    } else {
      repassword.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ repasswordErrorText: "" });
    }

    if (this.state.passwordValue === this.state.repasswordValue) {
      repassword.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ repasswordErrorText: "" });
    } else {
      repassword.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ repasswordErrorText: "رمز عبور ها با هم متفاوت است" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.repasswordValue,
      token: sessionStorage.getItem("token"),
    };

    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "signup";
    } else {
      apitype = "setForgetPassword";
    }

    fetch("/api/" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 201) {
          // sessionStorage.setItem("token", result.Token);
          this.LoginUser();
        } else if (result.status === 200) {
          this.props.history.push("/");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  };

  LoginUser() {
    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.repasswordValue,
      version: "1.0.0",
    };

    fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem("token", result.token);
          localStorage.setItem("mobile", sessionStorage.getItem("mobile"));
          sessionStorage.clear();
          if (result.notify.length > 0) {
            sessionStorage.setItem("title", result.notify[0].title);
            sessionStorage.setItem("description", result.notify[0].description);
          }
          this.props.history.push("/Steps/Brokers");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  }

  passwordHandleChange(event) {
    this.setState({ passwordValue: event.target.value });
  }

  repasswordHandleChange(event) {
    this.setState({ repasswordValue: event.target.value });
  }

  componentDidMount() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      this.refs.passwordInput.focus();
    }
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.loginClick();
    }
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ minWidth: "260px", maxWidth: "350px", width: "80%" }}>
            <div className="password">
              <label htmlFor="password">رمز عبور جدید</label>
              {/* <label htmlFor="password">رمز عبور</label> */}
              {/* <div style={{display:'flex',flexDirection:'row'}}>
                        <Form.Control
                            className="inputStyle"
                            placeholder="لطفاً رمز عبور جدید را وارد کنید"
                            type="password"
                            name="password"
                            id="password"
                            onChange={this.passwordHandleChange}
                            value={this.state.passwordValue}
                            disabled={this.state.buttonDisabled}
                            onKeyPress={this.handleKeyPress.bind(this)}
                            ref="passwordInput"
                        />
                    </div> */}
              <div className="InputWithIcon">
                <div className="inputImageDiv">
                  <img src={setpass} className="inputImage" alt="mobile" />
                </div>
                <Form.Control
                  className="inputStyle passDirection"
                  placeholder="لطفاً رمز عبور جدید را وارد کنید"
                  type="password"
                  name="password"
                  id="password"
                  onChange={this.passwordHandleChange}
                  value={this.state.passwordValue}
                  disabled={this.state.buttonDisabled}
                  onKeyPress={this.handleKeyPress.bind(this)}
                  ref="passwordInput"
                />
              </div>
              <div className="errorMessage" style={{ marginBottom: "20px" }}>
                {this.state.passwordErrorText}
              </div>
              {/* <label htmlFor="password">تکرار رمز عبور</label> */}
              {/* <div style={{display:'flex',flexDirection:'row',marginTop:'20px'}}>
                        <Form.Control
                            className="inputStyle"
                            placeholder="لطفاً رمز عبور جدید را تکرار کنید"
                            type="password"
                            name="repassword"
                            id="repassword"
                            onChange={this.repasswordHandleChange}
                            value={this.state.repasswordValue}
                            disabled={this.state.buttonDisabled}
                            onKeyPress={this.handleKeyPress.bind(this)}
                        />
                    </div> */}
              <div className="InputWithIcon">
                <div className="inputImageDiv">
                  <img src={setpass2} className="inputImage" alt="mobile" />
                </div>
                <Form.Control
                  className="inputStyle passDirection"
                  placeholder="لطفاً رمز عبور جدید را تکرار کنید"
                  type="password"
                  name="repassword"
                  id="repassword"
                  onChange={this.repasswordHandleChange}
                  value={this.state.repasswordValue}
                  disabled={this.state.buttonDisabled}
                  onKeyPress={this.handleKeyPress.bind(this)}
                />
              </div>
              <div className="errorMessage">
                {this.state.repasswordErrorText}
              </div>
            </div>
            <div className="createAccount">
              <Button
                id="btnLogin"
                style={{
                  width: "40%",
                  alignSelf: "flex-end",
                  float: "right",
                  fontSize: "14px",
                  height: "34px",
                }}
                disabled={this.state.buttonDisabled}
                onClick={this.loginClick}
              >
                {this.state.buttonSpinner && (
                  <Spinner
                    style={{ color: "white", height: "20px", width: "20px" }}
                    animation="border"
                  />
                )}
                {this.state.buttonText && <div>تایید</div>}
              </Button>
            </div>

            {this.state.actionError !== "" && (
              <div className="errorMessageContainer">
                <div>{this.state.actionError}</div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}

export default SetPassword;
